import React, { Component } from 'react';
import { observer } from 'mobx-react';
import SystemTranslationProgress from './SystemTranslationProgress';
import { browserHistory } from 'react-router';
import PropTypes from 'prop-types';
import SystemTranslationItemTypeInstructionProgressService from '../services/SystemTranslationItemTypeInstructionProgressService';

class SystemTranslationItemTypeInstructionProgressContainer extends Component {
  systemTranslationItemTypeInstructionProgressService = new SystemTranslationItemTypeInstructionProgressService();

  componentDidMount() {
    this.systemTranslationItemTypeInstructionProgressService.init(this.props.locale);
  }

  render() {
    return (
      <SystemTranslationProgress
        title="Item Types Instructions"
        percentage={this.systemTranslationItemTypeInstructionProgressService.progress.percentage}
        total={this.systemTranslationItemTypeInstructionProgressService.progress.translated}
        fetching={this.systemTranslationItemTypeInstructionProgressService.fetch.fetching}
        onClick={() =>
          browserHistory.push({
            pathname: '/item-types',
            query: {
              missingAudioForLocale: this.props.locale.key,
            },
            state: { from: { text: 'System Translations', pathname: '/system-translations' } },
          })
        }
      />
    );
  }
}

SystemTranslationItemTypeInstructionProgressContainer.propTypes = {
  locale: PropTypes.shape({
    key: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
  }).isRequired,
};

export default observer(SystemTranslationItemTypeInstructionProgressContainer);
